/** Persistence keys and schema version for local save adapter */
export const SAVE_KEY = 'compliance_command_save_v1';
export const SAVE_VERSION = '3.0.0';